<template>
  <div class="page-container">
    <PageHeader title="用户管理" show-breadcrumb />

    <SearchPanel>
      <el-input v-model.trim="query.zauName" placeholder="用户名" clearable size="small" @keyup.enter.native="handleSearch" />
      <el-input v-model.trim="query.zauPhone" placeholder="账号(手机号)" clearable size="small" @keyup.enter.native="handleSearch" />
      <el-select v-model="query.zauPost" placeholder="岗位" clearable size="small">
        <el-option v-for="item in postOptions" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
      <template #actions>
        <el-button type="primary" icon="el-icon-search" size="small" @click="handleSearch">查询</el-button>
        <el-button icon="el-icon-refresh" size="small" @click="handleReset">重置</el-button>
        <el-button type="success" icon="el-icon-plus" size="small" @click="handleAdd">新增用户</el-button>
      </template>
    </SearchPanel>

    <TablePanel title="用户列表">
      <el-table :data="list" v-loading="loading" size="small" stripe :height="tableHeight">
        <el-table-column type="index" label="序号" width="70" align="center" />
        <el-table-column label="头像" width="80" align="center">
          <template slot-scope="{ row }">
            <el-image v-if="row.zauHeader" :src="row.zauHeader" fit="cover" style="width:36px;height:36px;border-radius:50%" />
            <div v-else class="user-avatar-text">{{ (row.zauName || '用').slice(0, 1) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="zauName" label="用户名" min-width="120" align="center" show-overflow-tooltip />
        <el-table-column prop="zauPhone" label="账号" min-width="130" align="center" />
        <el-table-column label="岗位" min-width="110" align="center">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="postTagType(row.zauPost)">{{ postText(row.zauPost) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="avOwnerName" label="所属项目" min-width="140" align="center" show-overflow-tooltip />
        <el-table-column prop="createusername" label="创建人" min-width="110" align="center" show-overflow-tooltip />
        <el-table-column prop="createtime" label="创建时间" min-width="150" align="center" />
        <el-table-column label="操作" width="230" align="center" fixed="right">
          <template slot-scope="{ row }">
            <template v-if="canManageRow(row)">
              <el-button type="text" size="mini" style="color:#409eff" @click="handleEdit(row)">编辑</el-button>
              <el-button type="text" size="mini" style="color:#e6a23c" @click="handleResetPw(row)">重置密码</el-button>
              <el-button type="text" size="mini" style="color:#f56c6c" @click="handleDelete(row)">删除</el-button>
            </template>
            <span v-else class="text-muted">—</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      />
    </TablePanel>

    <!-- 新增/编辑用户弹框 -->
    <el-dialog :title="dialogType === 'add' ? '新增用户' : '编辑用户'" :visible.sync="dialogVisible" width="560px" v-dialog-drag-resize>
      <el-form ref="formRef" :model="form" :rules="rules" label-width="100px" size="small">
        <el-form-item label="用户名" prop="zauName">
          <el-input v-model.trim="form.zauName" placeholder="请输入用户名" />
        </el-form-item>
        <el-form-item label="账号" prop="zauPhone">
          <el-input v-model.trim="form.zauPhone" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item label="岗位" prop="zauPost">
          <el-select v-model="form.zauPost" placeholder="请选择岗位" style="width:100%" :disabled="isProjAdmin">
            <el-option v-for="item in postOptionsForForm" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <!-- 所属项目：仅系统管理员新增非系统管理员岗位时显示选择 -->
        <el-form-item v-if="dialogType === 'add' && isAdmin && form.zauPost !== 1" label="所属项目" prop="projectId">
          <el-select v-model="form.projectId" placeholder="请选择项目" filterable style="width:100%">
            <el-option v-for="p in projectOptions" :key="p.zapId" :label="p.zapName" :value="p.zapId" />
          </el-select>
        </el-form-item>
        <!-- 项目管理员新增用户：固定归属当前项目，只读提示 -->
        <el-form-item v-if="dialogType === 'add' && isProjAdmin" label="所属项目">
          <el-input :value="currentProjectName + '（当前项目）'" disabled />
        </el-form-item>
        <!-- 系统管理员岗位：全局账号提示 -->
        <el-form-item v-if="dialogType === 'add' && form.zauPost === 1" label="所属项目">
          <el-input value="全局账号（不限项目）" disabled />
        </el-form-item>
        <el-form-item label="密码" :prop="dialogType === 'add' ? 'zauPw' : ''">
          <el-input v-model.trim="form.zauPw" type="password" show-password :placeholder="dialogType === 'add' ? '请输入密码' : '留空则不修改密码'" />
        </el-form-item>
        <el-form-item label="头像">
          <CjUpload type="text" :filearr="form._headerArr" :limit="1" accept="image/*" @fileChange="onHeaderChange" @removeAfter="onHeaderRemove" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="submitLoading" @click="submitDialog">确定</el-button>
      </div>
    </el-dialog>

    <!-- 重置密码弹框 -->
    <el-dialog title="重置密码" :visible.sync="pwDialogVisible" width="420px" v-dialog-drag-resize>
      <el-form ref="pwFormRef" :model="pwForm" :rules="pwRules" label-width="90px" size="small">
        <el-form-item label="用户名">
          <span>{{ pwForm.zauName }}</span>
        </el-form-item>
        <el-form-item label="新密码" prop="zauPw">
          <el-input v-model.trim="pwForm.zauPw" type="password" show-password placeholder="请输入新密码" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="pwDialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="pwSubmitting" @click="submitResetPw">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'
import SearchPanel from '@/components/SearchPanel.vue'
import TablePanel from '@/components/TablePanel.vue'
import CjUpload from '@/components/cj-upload.vue'
import { getZqsxAuthUserList, addZqsxAuthUser, updateZqsxAuthUser, deleteZqsxAuthUser, resetZqsxAuthUserPw, getZqsxAuthProjectList } from '@/api/api'

// 岗位字典：1 系统管理员 2 项目管理员 3 用户
const POST_TEXT = { 1: '系统管理员', 2: '项目管理员', 3: '用户' }
const POST_TAG = { 1: 'danger', 2: 'warning', 3: 'info' }

export default {
  name: 'AuthUser',
  components: { PageHeader, SearchPanel, TablePanel, CjUpload },
  data () {
    return {
      loading: false,
      tableHeight: 400,
      list: [],
      query: { zauName: '', zauPhone: '', zauPost: null },
      page: { currentPage: 1, pageSize: 10, total: 0 },
      // 岗位筛选选项（列表含全部岗位，便于筛选普通用户）
      postOptions: [
        { value: 1, label: '系统管理员' },
        { value: 2, label: '项目管理员' },
        { value: 3, label: '普通用户' }
      ],
      projectOptions: [],
      dialogVisible: false,
      dialogType: 'add',
      submitLoading: false,
      form: this.buildForm(),
      pwDialogVisible: false,
      pwSubmitting: false,
      pwForm: { zauId: null, zauName: '', zauPw: '' },
      pwRules: { zauPw: [{ required: true, message: '请输入新密码', trigger: 'blur' }] }
    }
  },
  computed: {
    userInfo () { return this.$store.state.user.userInfo || {} },
    isAdmin () { return this.userInfo.zauPost === 1 },
    isProjAdmin () { return this.userInfo.zauPost === 2 },
    // 项目管理员当前所属项目名（用于新增用户时只读提示）
    currentProjectName () {
      const u = this.userInfo || {}
      return u.avOwnerName || (u.avOwnerId ? '项目' + u.avOwnerId : '当前项目')
    },
    // 表单中可选岗位（对齐后端权限）：
    // - 系统管理员(1)：可创建 系统管理员(1) / 项目管理员(2)
    // - 项目管理员(2)：只能创建 普通用户(3)
    postOptionsForForm () {
      if (this.isAdmin) {
        return [
          { value: 1, label: '系统管理员' },
          { value: 2, label: '项目管理员' }
        ]
      }
      // 项目管理员只能创建普通用户
      return [{ value: 3, label: '普通用户' }]
    },
    // 动态校验规则：
    // - 系统管理员岗位(1)：全局账号，所属项目非必填
    // - 项目管理员新增：项目固定为当前项目（已默认赋值），无需校验
    // - 系统管理员新增项目管理员：所属项目必填
    // - 密码：新增必填，编辑时可选（留空不改）
    rules () {
      const isGlobalAdmin = this.form.zauPost === 1
      const skipProjectCheck = isGlobalAdmin || this.isProjAdmin
      return {
        zauName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        zauPhone: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        zauPost: [{ required: true, message: '请选择岗位', trigger: 'change' }],
        projectId: skipProjectCheck ? [] : [{ required: true, message: '请选择项目', trigger: 'change' }],
        zauPw: this.dialogType === 'add'
          ? [{ required: true, message: '请输入密码', trigger: 'blur' }]
          : []
      }
    }
  },
  created () {
    this.fetchList()
    if (this.isAdmin) this.fetchProjects()
  },
  mounted () {
    this.$nextTick(this.calcTableHeight)
    window.addEventListener('resize', this.calcTableHeight)
  },
  beforeDestroy () { window.removeEventListener('resize', this.calcTableHeight) },
  methods: {
    postText (v) { return POST_TEXT[v] || '用户' },
    postTagType (v) { return POST_TAG[v] || 'info' },
    // 判断当前登录用户能否操作某行用户：
    // - 系统管理员(1)：可操作所有人
    // - 项目管理员(2)：只能操作普通用户(3)，不能动系统管理员(1)/项目管理员(2)
    canManageRow (row) {
      if (this.isAdmin) return true
      if (this.isProjAdmin) return row.zauPost === 3
      return false
    },
    buildForm () {
      return {
        zauId: null,
        zauName: '',
        zauPhone: '',
        zauPost: 2,
        projectId: null,
        zauPw: '',
        zauHeader: '',
        _headerArr: []
      }
    },
    calcTableHeight () {
      const el = this.$el.querySelector('.el-table')
      if (!el) return
      this.tableHeight = window.innerHeight - el.getBoundingClientRect().top - 80
    },
    async fetchList () {
      this.loading = true
      try {
        const params = { ...this.query, currentPage: this.page.currentPage, pageSize: this.page.pageSize }
        const res = await getZqsxAuthUserList(params)
        this.list = res.data || []
        this.page.total = res.total || 0
      } catch (e) { this.list = []; this.page.total = 0 } finally { this.loading = false }
    },
    // 系统管理员拉取项目下拉（新增用户时指定项目归属）
    async fetchProjects () {
      try {
        const res = await getZqsxAuthProjectList({ currentPage: 1, pageSize: 999 })
        this.projectOptions = res.data || []
      } catch (e) { this.projectOptions = [] }
    },
    handleSearch () { this.page.currentPage = 1; this.fetchList() },
    handleReset () { this.query = { zauName: '', zauPhone: '', zauPost: null }; this.handleSearch() },
    handleSizeChange (size) { this.page.pageSize = size; this.handleSearch() },
    handlePageChange (page) { this.page.currentPage = page; this.fetchList() },
    handleAdd () {
      this.dialogType = 'add'
      this.form = this.buildForm()
      // 默认岗位：项目管理员只能建普通用户(3)；系统管理员默认建项目管理员(2)
      this.form.zauPost = this.isAdmin ? 2 : 3
      // 项目管理员新增用户时，默认归属当前项目
      if (!this.isAdmin && this.userInfo.avOwnerId != null) {
        this.form.projectId = this.userInfo.avOwnerId
      }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    handleEdit (row) {
      this.dialogType = 'edit'
      this.form = {
        zauId: row.zauId,
        zauName: row.zauName || '',
        zauPhone: row.zauPhone || '',
        zauPost: row.zauPost,
        projectId: null,
        zauPw: '',
        zauHeader: row.zauHeader || '',
        _headerArr: row.zauHeader ? [{ url: row.zauHeader, name: '头像' }] : []
      }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    onHeaderChange (urls) {
      // 头像上传后回填 URL
      if (urls && urls.length) this.form.zauHeader = urls[urls.length - 1]
    },
    onHeaderRemove () { this.form.zauHeader = '' },
    submitDialog () {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.submitLoading = true
        try {
          if (this.dialogType === 'add') {
            await addZqsxAuthUser({
              zauName: this.form.zauName,
              zauPhone: this.form.zauPhone,
              zauPw: this.form.zauPw,
              zauPost: this.form.zauPost,
              // 系统管理员岗位为全局账号，显式传 0；否则取所选项目
              projectId: this.form.zauPost === 1 ? 0 : this.form.projectId,
              zauHeader: this.form.zauHeader
            })
            this.$message.success('新增成功')
          } else {
            await updateZqsxAuthUser({
              zauId: this.form.zauId,
              zauName: this.form.zauName,
              zauPhone: this.form.zauPhone,
              zauPw: this.form.zauPw,
              zauPost: this.form.zauPost,
              zauHeader: this.form.zauHeader
            })
            this.$message.success('编辑成功')
          }
          this.dialogVisible = false
          this.fetchList()
        } catch (e) {} finally {
          this.submitLoading = false
        }
      })
    },
    handleResetPw (row) {
      this.pwForm = { zauId: row.zauId, zauName: row.zauName, zauPw: '' }
      this.pwDialogVisible = true
      this.$nextTick(() => this.$refs.pwFormRef && this.$refs.pwFormRef.clearValidate())
    },
    submitResetPw () {
      this.$refs.pwFormRef.validate(async valid => {
        if (!valid) return
        this.pwSubmitting = true
        try {
          await resetZqsxAuthUserPw({ zauId: this.pwForm.zauId, zauPw: this.pwForm.zauPw })
          this.$message.success('密码重置成功')
          this.pwDialogVisible = false
        } catch (e) {} finally {
          this.pwSubmitting = false
        }
      })
    },
    async handleDelete (row) {
      try { await this.$confirm(`确定删除用户「${row.zauName}」？`, '提示', { type: 'warning' }) } catch { return }
      try {
        await deleteZqsxAuthUser({ zauId: row.zauId })
        this.$message.success('删除成功')
        this.fetchList()
      } catch (e) {}
    }
  }
}
</script>

<style lang="scss" scoped>
.user-avatar-text {
  width: 36px; height: 36px; border-radius: 50%; margin: 0 auto;
  display: flex; align-items: center; justify-content: center;
  background: linear-gradient(135deg, var(--fn-primary), var(--fn-accent));
  color: #fff; font-size: 14px; font-weight: 600;
}
</style>
